import { reducerWithInitialState } from "typescript-fsa-reducers";

import withImmer from "../../lib/withImmer";
import { loadProviders, authSucceeded, createSupport, Provider } from "../actions";
import { bootstrapCompanyProjects, loadCompanyProjects } from "../../companies/actions";

type Project = WtdModels.Partial<WtdModels.Project, "id" | "supported" | "can_support">;

export interface Provider {
  name: string;
  available: boolean;
  canPost: boolean;
}

interface SupportStatus {
  supportable: boolean;
  supported: boolean;
}

export interface ProjectSupportsState {
  projects: { [key: number]: SupportStatus };
  providers: Provider[];
  isLoadingProviders: boolean;
  isLoadedProviders: boolean;
}

function initProjects(projects: Project[]) {
  return projects.reduce(
    (acc, project) => {
      acc[project.id] = { supportable: project.can_support || false, supported: project.supported || false };
      return acc;
    },
    {} as ProjectSupportsState["projects"]
  );
}

const projectSupportsReducer = withImmer(
  reducerWithInitialState<ProjectSupportsState>({
    projects: {},
    providers: [],
    isLoadingProviders: false,
    isLoadedProviders: false,
  })
)
  .cases([bootstrapCompanyProjects], (state, action) => {
    state.projects = initProjects(action.projects);
    return state;
  })
  .cases([loadCompanyProjects.done], (state, action) => {
    state.projects = initProjects(action.result.projects);
    return state;
  })
  .case(loadProviders.started, state => {
    state.isLoadingProviders = true;
    return state;
  })
  .case(loadProviders.done, (state, action) => {
    state.providers = action.result;
    state.isLoadingProviders = false;
    state.isLoadedProviders = true;
    return state;
  })
  .case(loadProviders.failed, state => {
    state.isLoadingProviders = false;
    return state;
  })
  .case(authSucceeded, (state, providerName) => {
    const index = state.providers.findIndex(p => p.name === providerName);
    state.providers[index].canPost = true;
    return state;
  })
  .case(createSupport.done, (state, action) => {
    const { projectId } = action.params;
    state.projects[projectId as number] = { supportable: false, supported: true };
    return state;
  });

export default projectSupportsReducer;



// WEBPACK FOOTER //
// ./frontend/src/project_supports/reducers/index.ts